import { render, staticRenderFns } from "./StudyButtons.vue?vue&type=template&id=670dcc6c&scoped=true"
import script from "./StudyButtons.vue?vue&type=script&lang=js"
export * from "./StudyButtons.vue?vue&type=script&lang=js"
import style0 from "./StudyButtons.vue?vue&type=style&index=0&id=670dcc6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670dcc6c",
  null
  
)

export default component.exports